import { render, staticRenderFns } from "./conversation-header.vue?vue&type=template&id=76b528f0"
import script from "./conversation-header.vue?vue&type=script&lang=js"
export * from "./conversation-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports